import { countLabel } from "../benchmarkApi/reportData"
import { aboutContent } from "./aboutContent"

const headingClass =
  "text-balance text-[40px] font-bold leading-[48px] tracking-[-0.04em] text-[#171717] max-md:text-[28px] max-md:leading-8"

const bodyClass = "max-w-[68ch] text-[18px] font-normal leading-7 text-[#4D4D4D]"

export default function AboutSection({ statsStatus, totalCompanies }) {
  const count = countLabel(statsStatus, totalCompanies)

  return (
    <section className="flex w-full translate-x-[calc(50vw-50%-1.5rem)] flex-col gap-8">
      <div className="flex flex-col gap-3">
        <p className="text-[14px] font-medium leading-5 text-[#4D4D4D]">{aboutContent.eyebrow}</p>
        <h2 className={headingClass}>{aboutContent.title}</h2>
      </div>
      <div className="flex flex-col gap-4">
        {aboutContent.paragraphs.map((paragraph) => (
          <p key={paragraph} className={bodyClass}>
            {paragraph.replaceAll("{count}", count)}
          </p>
        ))}
        <p className={bodyClass}>
          <strong className="font-bold text-[#171717]">{aboutContent.architectLabel}</strong>{" "}
          {aboutContent.architectName}
        </p>
      </div>
    </section>
  )
}
